'use strict';

$(document).on('show.bs.modal', '.modal', function () {
  $('.modal.show').not(this).modal('hide');
});